export default __webpack_public_path__ + "static/media/CDJR-rotating-logos-GRY.06287307.gif";